import React from 'react';
import { useSelector } from 'react-redux';
import { objectiveGroupsWithObjectivesAndPointsSelector } from '../../slices/PatientSlice';
import ObjectiveGroupLogicHandler from './ObjectiveGroupLogicHandler/ObjectiveGroupLogicHandler';
import useEndSessionOnObjectivesCompleted from './useEndSessionOnObjectivesCompleted';

const ObjectivesLogicHandler = () => {
  useEndSessionOnObjectivesCompleted();
  const objectiveGroupsWithObjectivesAndPoints = useSelector(
    objectiveGroupsWithObjectivesAndPointsSelector
  );

  return (
    <>
      {objectiveGroupsWithObjectivesAndPoints.map((objectiveGroup) => (
        <ObjectiveGroupLogicHandler
          key={objectiveGroup.id}
          objectiveGroup={objectiveGroup}
        />
      ))}
    </>
  );
};

export default ObjectivesLogicHandler;
